import ozZapMagazine from './oz-zap-magazine.vue'

export default ozZapMagazine
